import React from "react";
import SantaFlight from "./SantaFlight";
import Twinkles from "./Twinkles";

/**
 * The home hero at Christmas: the snowy city from the new parallax art drifting
 * by, stars twinkling, and Santa crossing the sky between the two layers.
 *
 * A backdrop only — it fills the hero behind the page's own content (which
 * HomePage lifts above it), and nothing but the sleigh takes the pointer. The
 * background art is opaque, so the hero's own colour must match its sky:
 * FROST.sky, which is the art's top row.
 */

var asset = function (name) {
  return (process.env.PUBLIC_URL || "") + "/christmas/" + name;
};

/** The two parallax layers, shared with the maintenance page. */
export var PARALLAX_BACK = asset("parallax_background_christmas.webp");
export var PARALLAX_FRONT = asset("parallax_foreground_christmas.webp");

export default function ChristmasHero() {
  return (
    <div className="xm-hero-layer">
      <span className="xm-layer xm-layer-back" style={{ backgroundImage: "url(" + PARALLAX_BACK + ")" }} />
      <Twinkles count={10} seed={12} area={[3, 38]} />
      <SantaFlight top={18} band={190} />
      <span className="xm-layer xm-layer-front" style={{ backgroundImage: "url(" + PARALLAX_FRONT + ")" }} />
    </div>
  );
}
